import { render, staticRenderFns } from "./invite.vue?vue&type=template&id=527adc78&scoped=true&"
import script from "./invite.vue?vue&type=script&lang=js&"
export * from "./invite.vue?vue&type=script&lang=js&"
import style0 from "./invite.vue?vue&type=style&index=0&id=527adc78&scoped=true&lang=css&"
import style1 from "./invite.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "527adc78",
  null
  
)

export default component.exports